module.exports = __webpack_public_path__ + "files/bc3c1dc89857751281d37f42757ea125.png";